import * as React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './InquiryForm.module.css';
import { useFormValues } from 'hooks/useFormValues';
import { InquiryFormValues } from './InquiryFormValues';

export const InquirySummary = () => {
  const { t, i18n } = useTranslation();

  const values = useFormValues<InquiryFormValues>();

  return (
    <div className={styles['post-form']}>
      {values.category && (
        <div className={styles['post-form__box']}>
          <div className={styles['post-form__box__ttl']}>{t('Category')}</div>
          <div className={styles['post-form__box__body']}>{values.category}</div>
        </div>
      )}

      <div className={styles['post-form__box']}>
        <div className={styles['post-form__box__ttl']}>{t('Title')}</div>
        <div className={styles['post-form__box__body']}>{values.title}</div>
      </div>

      <div className={styles['post-form__box']}>
        <div className={styles['post-form__box__ttl']}>{t('Description of issue')}</div>
        <div className={clsx(styles['post-form__box__body'], 'newline')}>{values.body}</div>
      </div>

      {i18n.language === 'ja-JP' ? (
        <>
          <div className={styles['post-form__box']}>
            <div className={styles['post-form__box__ttl']}>{t('Family Name')}</div>
            <div className={styles['post-form__box__body']}>{values.familyName}</div>
          </div>

          <div className={styles['post-form__box']}>
            <div className={styles['post-form__box__ttl']}>{t('Given Name')}</div>
            <div className={styles['post-form__box__body']}>{values.givenName}</div>
          </div>
        </>
      ) : (
        <>
          <div className={styles['post-form__box']}>
            <div className={styles['post-form__box__ttl']}>{t('Given Name')}</div>
            <div className={styles['post-form__box__body']}>{values.givenName}</div>
          </div>

          <div className={styles['post-form__box']}>
            <div className={styles['post-form__box__ttl']}>{t('Family Name')}</div>
            <div className={styles['post-form__box__body']}>{values.familyName}</div>
          </div>
        </>
      )}

      <div className={styles['post-form__box']}>
        <div className={styles['post-form__box__ttl']}>{t('Email')}</div>
        <div className={styles['post-form__box__body']}>{values.email}</div>
      </div>
    </div>
  );
};
